import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Competency} from '../models/competency';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompetencyService {

  constructor(private http: HttpClient) { }

  getAllCompetency(): Observable<Competency[]> {
    return this.http.get<Competency[]>(`${environment.api_endpoint}/competencys`)
  }
}
